<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--返回上一页-->
    <div class="backBg">
      <a href="javascript:history.go(-1)">
        <div class="backBox">
          <span class="backIcon"></span>
        </div>
      </a>
      <div class="topTitle">
        <span >编码详情</span>
      </div>
    </div>
    <div class="content_bg">
      <div class="">
        <!--搜索框-->
        <div class="searchBg2">
          <div class="weui-search-bar" id="searchBar" ref="searchBar">
            <form class="weui-search-bar__form">
              <div class="weui-search-bar__box">
                <i class="weui-icon-search"></i>
                <input type="search" class="weui-search-bar__input" id="searchInput" ref="searchInput" placeholder="搜索编号查询~" required @blur="blurSearch" @input="checkSearch"/>
                <a href="javascript:" class="weui-icon-clear" id="searchClear" ref="searchClear" @click="clearSearch"></a>
              </div>
              <label class="weui-search-bar__label" id="searchText" ref="searchText" @click="clickSearch">
                <i class="weui-icon-search"></i>
                <span>搜索编号查询~</span>
              </label>
            </form>
            <a href="javascript:" class="weui-search-bar__cancel-btn" style="color: #000 !important;" id="searchSubmit" ref="searchSubmit" @click="search">取消</a>
          </div>
        </div>

        <!--列表-->
        <div class="check_list_bg">
          <div class="code_detail_box">
            <table style="border-collapse: collapse;width: 100%;">
              <tr>
                <th>制造单号</th>
                <th>编号</th>
                <th>SIZE</th>
                <th>操作人</th>
                <th>操作时间</th>
              </tr>
              <tr v-for="item in list">
                <td>{{ item.order_no }}</td>
                <td>{{ item.no }}</td>
                <td>{{ item.size }}</td>
                <td>{{ item.user_id }}</td>
                <td>{{ item.add_time }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <loading v-show="loading"></loading>
  </div>
</template>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import loading from '@/components/loading'
  export default {
    name:'codeDetail',
    components:{
      loading,
    },
    data(){
      return{
        list:'',
        loading:false,
        now_page:'',
        page_size:'',
        page_count:'',
      }
    },
    created:function () {
      var that = this;
      var token = localStorage.getItem('token');
      var order_id = that.$route.query.order_id;
      var type = that.$route.query.type;
      var size_id = that.$route.query.size_id;
      var date = that.$route.query.date;
      console.log(date);
      var now_page = 1;
      var page_size = 20;
      var formData = new FormData();
      formData.append('token',token);
      formData.append('order_id',order_id);
      formData.append('type',type);
      formData.append('now_page',now_page);
      formData.append('page_size',page_size);
      that.loading = true;
//      非日期查询
      if( date !== undefined ){
        formData.append('date',date);
        that.app.postData('/mhome.php/Count/dateDetail',formData
          ,result =>{
            if( result.status == 503 ){
              webToast('暂无数据','middle',1500);
//            return false;
            }else{
              that.list = result.content.list_data;
              that.now_page = result.content.now_page;
              that.page_count = result.content.page_count;
            }
          },()=>{
            that.loading = false;
          })
        return false;
      }else{
        formData.append('size_id',size_id);
        that.app.postData('/mhome.php/Count/noDetail',formData
          ,result =>{
            if( result.status == 503 ){
              webToast('暂无数据','middle',1500);
//            return false;
            }else{
              that.list = result.content.list_data;
              that.now_page = result.content.now_page;
              that.page_count = result.content.page_count;
            }
          },()=>{
            that.loading = false;
          })
      }
      //    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      点击搜索框
      clickSearch(){
        this.$refs.searchBar.classList.add('weui-search-bar_focusing');
        this.$refs.searchInput.focus();
      },
//      取消搜索
      cancelSearch(){
        this.$refs.searchBar.classList.remove('weui-search-bar_focusing');
        this.$refs.searchInput.blur();
      },
//      清除搜索内容
      clearSearch(){
        this.$refs.searchInput.focus();
        this.$refs.searchInput.value = '';
        this.$refs.searchSubmit.innerHTML = '取消';
      },
//      搜索框失去焦点
      blurSearch(){
        if(!this.$refs.searchInput.value.length){
          this.cancelSearch();
          this.$refs.searchSubmit.innerHTML = '取消';
        }
      },
//      监听搜索
      checkSearch(){
        if(this.$refs.searchInput.value.length){
          this.$refs.searchSubmit.innerHTML = '搜索';
        }
      },
//      点击搜索
      search(){
        if(this.$refs.searchInput.value.length){
          var that = this;
          var token = localStorage.getItem('token');
          var order_id = that.$route.query.order_id;
          var type = that.$route.query.type;
          var no = that.$refs.searchInput.value;
          var date = that.$route.query.date;
          var now_page = 1;
          var page_size = 20;
          var formData = new FormData();
          formData.append('token',token);
          formData.append('order_id',order_id);
          formData.append('type',type);
          formData.append('no',no);
          formData.append('now_page',now_page);
          formData.append('page_size',page_size);
          that.loading = true;
          //      非日期查询
          if( date !== undefined ){
            formData.append('date',date);
            that.app.postData('/mhome.php/Count/dateDetail',formData
              ,result =>{
                if( result.status == 503 ){
                  webToast('暂无数据','middle',1500);
//            return false;
                }else{
                  that.list = result.content.list_data;
                  that.now_page = result.content.now_page;
                  that.page_count = result.content.page_count;
                }
              },()=>{
                that.loading = false;
              })
            return false;
          }else{
            that.app.postData('/mhome.php/Count/noDetail',formData
              ,result =>{
                if( result.status == 503 ){
                  webToast('暂无数据','middle',1500);
//            return false;
                }else{
                  that.list = result.content.list_data;
                  that.now_page = result.content.now_page;
                  that.page_count = result.content.page_count;
                }
              },()=>{
                that.loading = false;
              })
          }
        }
      },
//      触底加载
      handleScroll (e) {
        var that = this;
        var token = localStorage.getItem('token');
        var bottomScrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight - window.pageYOffset ;
        if( bottomScrollHeight == 0 ){
          if( Number(that.now_page) + 1 <= that.page_count ){
            var formData = new FormData();
            var order_id = that.$route.query.order_id;
            var type = that.$route.query.type;
            formData.append('token',token);
            formData.append('order_id',order_id);
            formData.append('type',type);
            formData.append('now_page',Number(that.now_page) + 1);
            formData.append('page_size',20);
            that.app.postData('/mhome.php/Count/noDetail',formData,
              result =>{
                that.loading = false;
                var list = result.content.list_data;
                var nowPage = result.content.now_page;
                var pageCount = result.content.page_count;
                that.list = that.list.concat(list);
                that.now_page = nowPage;
                that.page_count = pageCount;
              },() =>{
                that.loading = false;
              })
          }
        }
      },
    },
    //    监听滚动条
    mounted(){
      window.addEventListener('scroll',this.handleScroll,true);
    },
    beforeRouteEnter(to,from,next){
      window.document.body.style.background  = '#fff';
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.removeEventListener('scroll',this.handleScroll,true);
//      window.document.body.style.background = '#f4f4f4';
      next();
    }
  }
</script>

<style>
  th{
    background: #4598FF;
    color: #fff !important;
  }
  table tr{
    display: flex;
  }
  td ,th{
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/codeDetail.vue